import { render, staticRenderFns } from "./RELStatusVeiculos.vue?vue&type=template&id=560a5655&scoped=true&"
import script from "./RELStatusVeiculos.vue?vue&type=script&lang=js&"
export * from "./RELStatusVeiculos.vue?vue&type=script&lang=js&"
import style0 from "./RELStatusVeiculos.vue?vue&type=style&index=0&id=560a5655&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560a5655",
  null
  
)

export default component.exports